<template>
    <forms-text-field
        v-bind="$attrs"
        label="CEP"
        v-model="model"
        v-mask="'99999-999'" 
        :error-messages="errorMessages" 
        @keyup-enter="search()"
        :clearable="clearable"
        :loading="loading"
        :disabled="loading"
    >

    </forms-text-field>
</template>

<script setup>

import { computed, ref } from 'vue'
import { useHttp } from '@/composables/useHttp';

const http = useHttp();
const api = process.env.VUE_APP_ROOT;
const loading = ref(false);

const props = defineProps({
    value: { type: String, required: false },
    errorMessages:  { type: Array, required: false },
    clearable: { type: Boolean, default: false },
})

const emit = defineEmits(['input', 'address'])

const model = computed({
    get() {
        return props.value
    },
    set(val) {
        emit('input', val)
    }
})

const search = () => {

    loading.value = true;

    let cleanCep = (model.value || '').replace(/\D/g, ''); // Remove caracteres não numéricos

    http.get(api + 'api/address/search-cep', { params: { cep: cleanCep } })
        .then(response => {
            emit('address', response.data.data)
        })
        .catch(error => {
            //console.error('Erro ao buscar CEP:', error)
        })
        .finally(() => {
            loading.value = false;
        });
}

</script>